'use client';

import { c as _c } from "react/compiler-runtime";
import { useFundingCardAddition } from '@morfi/onramp-sdk/react';
import type { MoonPayWebProvider } from '@morfi/onramp-sdk/web';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';
import { FundingCardEntry } from '../checkout/funding-card-entry';
import { useFundingStage } from '../shared/funding-chrome';
export function FundingProfileAddCard(t0) {
  const $ = _c(5);
  const {
    provider,
    onBack,
    onComplete
  } = t0;
  const t = useTranslations("onramp");
  const entry = useFundingCardAddition(onComplete);
  let t1;
  if ($[0] !== t) {
    t1 = t("add_card");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useFundingStage(t1, false, onBack);
  let t2;
  if ($[2] !== entry || $[3] !== provider) {
    t2 = <FundingCardEntry provider={provider} checkout={entry} />;
    $[2] = entry;
    $[3] = provider;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}